import { Box, Container, Divider, Typography, styled } from "@mui/material";
import React, { useCallback } from "react";
import Particles from "react-particles";
import { loadFull } from "tsparticles";
import logo from "../../Components/images/mainlogo.png";
import { useState } from "react";
import HorizontalNav from "./HorizontalNav";
import { MenuRounded } from "@mui/icons-material";
import { NavLink } from "react-router-dom";
const data = [
  {
    title: "Home",
    path: "/",
  },

  {
    title: "White paper",
    path: "/whitepaper",
  },

  {
    title: "Dapp",
    path: "/staking",
  },
  {
    title: "Farming",
    path: "/farming",
  },
];

const StyledLink = styled(NavLink)(() => ({
  textDecoration: "none",
  "&:focus, &:hover, &:visited, &:link, &:active": {
    textDecoration: "none",
    color: "black",
  },
}));

const NewHeroSection = () => {
  const [state, setState] = useState(false);

  const toggleDrawer = (open) => {
    setState((prevState) => !prevState);
  };

  const particlesInit = useCallback(async (engine) => {
    console.log(engine);
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    console.log(container);
  }, []);

  const particleOptions = {
    autoPlay: true,
    background: {
      color: {
        value: "transparent",
        opacity: "0.2",
      },
    },
    fpsLimit: 120,
    interactivity: {
      events: {
        onHover: {
          enable: true,
          mode: "grab",
        },
      },
      modes: {
        grab: {
          distance: 200,
          links: {
            opacity: 0.8,
          },
        },
      },
    },
    particles: {
      number: {
        value: 200,
      },
      color: {
        value: "#a0c8f0",
      },
      shape: {
        type: "polygon",
        polygon: {
          sides: 15,
        },
      },
      move: {
        // Enable particle movement
        enable: true,
        // Set the speed of particles
        speed: 2,
        // Enable particles to bounce off the edges
        bounce: true,
      },

      size: {
        value: 1, // Decrease the value to decrease particle size
        random: true, // Enable random size variation
        anim: {
          enable: false, // Disable size animation
          speed: 0, // Set animation speed to 0 (disabled)
          size_min: 0, // Set minimum size during animation
        },
      },
    },
  };

  return (
    <Box
      sx={{
        position: "relative",
        background: "#000",
        width: "100%",
        minHeight: "100vh",
        height: "100%",
      }}
    >
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={particleOptions}
      />

      <Container>
        <Box
          sx={{ position: "absolute", top: 0, left: 10, right: 10, bottom: 0 }}
        >
          <HorizontalNav toggleDrawer={toggleDrawer} state={state} />

          <StyledLink to="/">
            <Box component="img" src={logo} alt="" width={"100px"} />
          </StyledLink>

          <Box
            height={"75%"}
            display={"flex"}
            gap={10}
            alignItems={"center"}
            ml={3}
          >
            <Box
              display={"flex"}
              flexDirection={"column"}
              alignItems={"center"}
            >
              <Typography color="#fff">Menu</Typography>
              <MenuRounded
                sx={{ color: "#fff", fontSize: "3rem", cursor: "pointer" }}
                onClick={() => toggleDrawer(true)}
              />
            </Box>
            <Box width={{ lg: "60%", md: "80%" }}>
              <Typography
                sx={{
                  fontSize: "40px",
                  fontFamily: "Roboto Slab",
                  color: "#CA3A38",
                  fontWeight: "900",
                }}
              >
                Welcome to the DeFi Sage {""}
                <Typography
                  component={"span"}
                  sx={{
                    fontSize: "30px",
                    fontFamily: "Roboto Slab",
                    color: "#fff",
                    fontWeight: "900",
                    ml: 0.3,
                  }}
                >
                  where decentralized finance meets limitless possibilities!
                </Typography>
              </Typography>

              <Typography
                sx={{
                  fontSize: "20px",
                  color: "#fff",
                  fontFamily: "Lato",
                  mt: 1,
                }}
              >
                To the future of finance, where trust is secured by the
                blockchain and financial freedom is within your reach.
              </Typography>
            </Box>
          </Box>
          <Box px={18}>
            <Divider sx={{ bgcolor: "gray" }} />

            <Box
              display="flex"
              justifyContent={"flex-start"}
              gap={5}
              mt={2}
              pl={2}
            >
              {data.map((item, i) => {
                return (
                  <NavLink
                    to={item?.path}
                    style={{ textDecoration: "none", color: "white" }}
                    key={i}
                  >
                    <Typography
                      key={i}
                      className="rainfall-button"
                      sx={{
                        cursor: "pointer",
                        mt: 2,
                        textAlign: "left",
                        fontFamily: "Lato",
                        fontSize: "25px",
                        transition: "1s ease-in-out",
                        color: `#fff`,
                        "&:hover": {
                          transition: "1s ease-in-out",
                          color: `#E0115F`,
                        },
                      }}
                    >
                      {item?.title}
                    </Typography>
                  </NavLink>
                );
              })}
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default NewHeroSection;
